/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TabSortable } from '../tab/tab.Sortable';
import { getId, isBuiltinTabId, isTabCampaignAccessible } from '../../utils/item';
import {
  FaCogs,
  FaHome,
  FaKey,
  FaSearch,
  FaTimes,
  FaUser,
} from 'react-icons/fa';
import {
  setDrawerOpen,
  setNavigationOpen,
  setOpenModales,
} from '../../store/global';
import { ThemeChange } from '../theme/theme.Change';
import { NavigationManagePassword } from '../navigation/navigation.Passwords';
import { linkWithMJparam } from '../../utils/roles';
import { isMjForItem } from '../../utils/auth';
import { SpeedDial, SpeedDialAction } from '@mui/material';

export const ItemMobileNavigation = props => {
  const { itemId, currentBoard, displayType } = props;
  const item = useSelector(state => state.items[itemId]);
  const items = useSelector(state => state.items);
  const navigation = useSelector(state => state.global.navigation);
  const listCampaignsId = useSelector(state => state.global.listCampaignsId);
  const hasMjForItem = isMjForItem(item, items);
  const dispatch = useDispatch();

  const [tabs, setTabs] = useState([]);

  useEffect(() => {
    if (item?.tabs) {
      const sideTabs = new Set(
        item.tabs.map(
          objTab =>
            objTab[Object.keys(objTab)].position === 'sidebar' && {
              [objTab[Object.keys(objTab)]._id]: objTab[Object.keys(objTab)],
            }
        )
      );
      sideTabs.delete(false);
      const filteredTabs = Array.from(sideTabs).filter(tabObj => {
        const tabId = getId(tabObj);
        const tab = items?.[tabId];
        if (!tab) {
          return isBuiltinTabId(tabId);
        }
        return isTabCampaignAccessible(tab, items, listCampaignsId);
      });
      setTabs(filteredTabs);
    }
  }, [item?.tabs, items, listCampaignsId]);

  useEffect(() => {
    // Empêche la navigation arrière
    window.history.pushState(null, '', window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };

    // Nettoyage
    return () => {
      window.onpopstate = null;
    };
  }, []);

  return (
    <div className='flex flex-1 items-center text-contrast'>
      {tabs.map(tabObj => (
        <TabSortable
          key={getId(tabObj)}
          id={getId(tabObj)}
          tabId={getId(tabObj)}
          itemId={itemId}
          isOnMobile={true}
          mobileCurrentTab={currentBoard}
        />
      ))}

      <NavigationManagePassword />

      {displayType === 'drawer' ? (
        <div className='text-secondary flex-1 flex justify-center items-center mb-1'>
          <FaTimes
            size={25}
            onClick={() => dispatch(setDrawerOpen(null))}
          />
        </div>
      ) : (
        <SpeedDial
          ariaLabel='SpeedDial basic example'
          sx={{ position: 'absolute', bottom: 0, right: 0 }}
          icon={<FaCogs size={20} />}
        >
          <SpeedDialAction
            icon={
              <div className='bg-primary-d p-05 rounded-full'>
                <FaHome />
              </div>
            }
            //   tooltipTitle='Accueil'
            tooltipOpen={false}
            onClick={() => {
              dispatch(setDrawerOpen(null));
              window.location.href = `/${
                hasMjForItem ? '?' + linkWithMJparam() : ''
              }`;
            }}
          />
          <SpeedDialAction
            icon={
              <div className='bg-primary-d p-05 rounded-full'>
                <ThemeChange />
              </div>
            }
          />
          <SpeedDialAction
            icon={
              <div className='bg-primary-d p-05 rounded-full'>
                <FaKey />
              </div>
            }
            //   tooltipTitle='Générer un mot de passe'
            tooltipOpen={false}
            onClick={() => {
              dispatch(setOpenModales({ id: 'managePassword', open: true }));
            }}
          />
          <SpeedDialAction
            icon={
              <div className='bg-primary-d p-05 rounded-full'>
                {navigation.open ? <FaUser /> : <FaSearch />}
              </div>
            }
            onClick={() => {
              dispatch(setNavigationOpen(!navigation.open));
            }}
          />
        </SpeedDial>
      )}
    </div>
  );
};
